import { gql } from "@apollo/client";

export const INSURANCE_PLANS = gql`
  query InsurancePlans(
    $where: InsurancePlanWhereInput
    $take: Int
    $skip: Int
    $isIn: JSONObject
    $like: InsurancePlanWhereInput
    $orderBy: [InsurancePlanWhereInput]
    $custom: JSONObject
    $rules: [InsurancePlanRuleFilterInput!]
  ) {
    insurancePlans(
      where: $where
      take: $take
      skip: $skip
      isIn: $isIn
      like: $like
      orderBy: $orderBy
      custom: $custom
      rules: $rules
    ) {
      data {
        id
        identifier
        externalId
        name
        alias
        icon
        description
        risk
        product
        category
        documentTemplates {
          templateId
          templateName
          type
          area
          outputName
          conditions
        }
        params {
          id
          rules {
            id
            name
            value
          }
        }
        fields
        config
        active
        internal
        commissions {
          id
          type
          value
          withholding
        }
        supportingInformation {
          id
          category
          value
          weight
        }
      }
      count
    }
  }
`;

export const INSURANCE_PLAN = gql`
  query InsurancePlan($where: InsurancePlanWhereInput) {
    insurancePlan(where: $where) {
      id
      identifier
      externalId
      name
      alias
      level
      icon
      description
      active
      product
      internal
      isStandalone
      risk
      category
      params {
        id
        rules {
          id
          name
          predicate
          required
          value
        }
      }
      fields
      config
      recommendationRules
      startDate
      endDate
      commissions {
        id
        type
        value
        withholding
      }
      supportingInformation {
        id
        category
        value
        weight
      }
      zoneType
      zones {
        id
        name
        description
        values
        order
      }
      ageBrackets {
        id
        name
        minAge
        maxAge
        order
      }
      regimes {
        id
        name
        code
        order
      }
      documentTemplates {
        templateId
        templateName
        type
        area
        outputName
        conditions
      }
      insurancePlanCoverages {
        id
        carenceDays
        coverageCategory {
          id
          value
          label
          icon
          order
          weight
        }
        needs {
          id
          level
        }
        pricer {
          id
          name
          type
          prices
          discount
          startDate
          endDate
        }
        coverageMappings {
          id
          waitingDays
          carenceDays
          coverage {
            id
            type
            requirement
            subtype
            order
          }
          limits {
            id
            code
            value
            upsells {
              id
              name
            }
          }
          supportingInformation {
            id
            category
            value
            weight
          }
          pricer {
            id
            name
            type
            prices
            discount
            startDate
            endDate
          }
        }
      }
    }
  }
`;

export const INSURANCE_PLAN_CHOICES = gql`
  query InsurancePlanChoices(
    $where: InsurancePlanWhereInput
    $orderBy: [InsurancePlanWhereInput]
  ) {
    insurancePlans(where: $where, orderBy: $orderBy, take: null) {
      data {
        id
        name
        alias
        identifier
        product
        level
        isStandalone
      }
    }
  }
`;

export const INSURANCE_PLAN_PRICING_AXES = gql`
  query InsurancePlanPricingAxes($where: InsurancePlanWhereInput) {
    insurancePlan(where: $where) {
      id
      zoneType
      zones {
        id
        name
        order
      }
      ageBrackets {
        id
        name
        minAge
        maxAge
        order
      }
      regimes {
        id
        name
        code
        order
      }
    }
  }
`;

export const EXPORT_INSURANCE_PLANS = gql`
  query ExportInsurancePlans($ids: [ID!]!) {
    exportInsurancePlans(ids: $ids)
  }
`;

const products = {
  INSURANCE_PLANS,
  INSURANCE_PLAN,
  INSURANCE_PLAN_CHOICES,
  INSURANCE_PLAN_PRICING_AXES,
  EXPORT_INSURANCE_PLANS,
};

export default products;
